module.exports = __webpack_public_path__ + "img/home-line3-img4.5a42b4f7.png";